/** Page buttons: the first, the last, and the current page ±1, with … for the gaps. */
export function pagerRange(page: number, total: number): (number | '…')[] {
  const out: (number | '…')[] = [];
  for (let n = 1; n <= total; n++) {
    if (n === 1 || n === total || Math.abs(n - page) <= 1) out.push(n);
    else if (out[out.length - 1] !== '…') out.push('…');
  }
  return out;
}

/** One page of rows, plus the numbers the pager prints. `page` is clamped to the last page. */
export function pageOf<T>(rows: T[], page: number, size: number) {
  const totalPages = Math.max(1, Math.ceil(rows.length / size));
  const safePage = Math.min(Math.max(1, page), totalPages);
  const start = (safePage - 1) * size;
  return {
    items: rows.slice(start, start + size),
    safePage,
    totalPages,
    first: rows.length ? start + 1 : 0,
    last: Math.min(start + size, rows.length),
  };
}

/**
 * ehr#477: one page of a list made of two runs (the client's progress notes, then their
 * imported notes), each run cut to the rows that fall on the page.
 */
export function pageOfTwo<A, B>(a: A[], b: B[], page: number, size: number) {
  const pg = pageOf<A | B>([...a, ...b], page, size);
  const from = pg.first ? pg.first - 1 : 0;
  return {
    ...pg,
    a: a.slice(from, pg.last),
    b: b.slice(Math.max(0, from - a.length), Math.max(0, pg.last - a.length)),
  };
}
